module.exports = __webpack_public_path__ + "img/picada_mixta.bd185317.jpg";